/* Dabi Deri - paylasim: bagalanti kopyalama geri bildirimi */
(() => {
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-dabi-copy]');
    if (!btn) return;

    const root = btn.closest('[data-dabi-share]');
    const feedback = root?.querySelector('[data-dabi-share-feedback]');
    const url = btn.dataset.dabiCopy;

    const legacyCopy = () => {
      const tmp = document.createElement('input');
      tmp.value = url;
      tmp.setAttribute('readonly', '');
      tmp.style.position = 'fixed';
      tmp.style.opacity = '0';
      document.body.appendChild(tmp);
      tmp.select();
      const ok = document.execCommand('copy');
      tmp.remove();
      if (!ok) throw new Error('copy failed');
    };

    try {
      // Clipboard API izin/baglam nedeniyle hata verebiliyor; o durumda eski yonteme dusuyoruz.
      if (!navigator.clipboard?.writeText) {
        // iOS'ta kullanici hareketi penceresi await sonrasi kapaniyor; once es zamanli dene.
        legacyCopy();
      } else {
        try {
          await navigator.clipboard.writeText(url);
        } catch {
          legacyCopy();
        }
      }
      btn.classList.add('is-copied');
      if (feedback) feedback.textContent = window.accessibilityStrings?.shareSuccess || '';
      setTimeout(() => {
        btn.classList.remove('is-copied');
        if (feedback) feedback.textContent = '';
      }, 2200);
    } catch {
      if (feedback) feedback.textContent = url;
    }
  });
})();
